import axios from "axios";
import { API_BASE_URL, SOCKET_URL } from "./config";

export const url = API_BASE_URL;

const token = localStorage.getItem("authorization");
export default axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
    Authorization: JSON.parse(token),
  },
});

export { SOCKET_URL };
